import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4c484877")

_pushScopeId("data-v-4c484877")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createVNode("h3", { class: "dialog-confirm__title" }, " Language "),
  /*#__PURE__*/_createVNode("div", { class: "dialog-confirm__message" }, " Select language ")
], -1)
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "selector-label" }
const _hoisted_4 = {
  key: 0,
  class: "selector-badge bg-primary text-white"
}
const _hoisted_5 = { class: "dialog-confirm__footer mt-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDialogVisible = $event)),
    onHide: _ctx.doHideDialog,
    modal: true,
    showHeader: false,
    closable: false,
    class: "dialog-confirm"
  }, {
    default: _withId(() => [
      _hoisted_1,
      _createVNode("div", _hoisted_2, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.languages, (language) => {
          return (_openBlock(), _createBlock("div", {
            key: language.name,
            onClick: ($event: any) => (_ctx.selectLanguage(language)),
            class: "selector-item"
          }, [
            _createVNode("div", _hoisted_3, _toDisplayString(language.name), 1),
            (_ctx.selectedLanguageInside?.code === language.code)
              ? (_openBlock(), _createBlock("div", _hoisted_4, "✓"))
              : _createCommentVNode("", true)
          ], 8, ["onClick"]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          class: "p-button-text p-button-secondary text-uppercase mr-2",
          onClick: _ctx.handleHideDialog
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Cancel")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "p-button-rounded p-button--m",
          onClick: _ctx.doConfirm
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Confirm")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
})